import { validateForUI } from 'common/helpers/jsonValidator';

const exchangeSchema = {
  type: 'object',
  properties: {
    swapWithProductVariantId: { type: 'string', format: 'uuid' }
  },
  required: ['swapWithProductVariantId'],
  additionalProperties: false
};

export const validateExchange = (exchange) => {
  const errors = validateForUI(exchangeSchema, exchange);
  return errors;
};
